import { ComponentProps, ReactNode } from 'react';
import { MaterialSymbol, withStyles } from 'vopay';
import styles from './ListItem.module.scss';
import { Link } from 'react-router-dom';

const cn = withStyles(styles);

type ListItemProps = {
  content: ReactNode;
  icon: ReactNode;
  to?: ComponentProps<typeof Link>['to'];
  className?: string;
  onClick?: () => void;
};

export default function ListItem({ content: contentProp, icon, to, className, onClick }: ListItemProps) {
  const content = (
    <>
      <div className={cn('icon')}>{icon}</div>
      <div className={cn('middle')}>{contentProp}</div>
      <MaterialSymbol icon="keyboard_arrow_right" size="24px" />
    </>
  );

  if (to) {
    return (
      <Link to={to} className={cn('listItem', className)} onClick={onClick}>
        {content}
      </Link>
    );
  }

  if (onClick) {
    return (
      <button type="button" className={cn('listItem', className)} onClick={onClick}>
        {content}
      </button>
    );
  }

  return <div className={cn('listItem', className)}>{content}</div>;
}
